<script setup>
const _props = defineProps({
  firstTeam: {
    type: Object,
    required: true,
  },
  secondTeam: {
    type: Object,
    required: true,
  },
  showCity: {
    type: Boolean,
    default: true,
  },
  isHomeLogoWithOpponent: {
    type: Boolean,
    default: true,
  },
  name: {
    type: String,
    default: '',
  },
});
</script>

<template>
  <div class="i-teams">
    <div class="i-teams__name">
      <span v-if="isHomeLogoWithOpponent">
        "{{ firstTeam.name }}" VS "{{ secondTeam.name }}"
      </span>
      <span v-else>
        "{{ name || firstTeam.name }}"
      </span>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "frontend/web/src/styles/utils/variables.scss";
@import "./i-teams.scss";
</style>
